import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

import { getColorVariable } from './constants'

function IconColoredHorizonS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2 10.5027C2 10.5027 3.27909 8.10413 6.5 8.10413C9.72091 8.10413 14 11.1041 14 11.1041V7.60413C13.6667 6.93746 12.5 5.50413 10.5 5.10413C7.29928 4.46398 3.92822 6.30412 2 8.10413V10.5027Z"
        fill={getColorVariable()}
      />
      <path
        d="M2 11.5846V13.6249C2.00639 13.605 2.01677 13.5738 2.03157 13.533C2.06179 13.4497 2.11024 13.3268 2.18054 13.1776C2.32161 12.8782 2.54783 12.4788 2.88646 12.0806C3.55485 11.2949 4.66989 10.4999 6.49999 10.4999C8.35982 10.4999 10.2923 11.3815 11.7971 12.3069C12.5418 12.7649 13.1657 13.2234 13.603 13.5673C13.7611 13.6916 13.8945 13.8006 14 13.8889V12.6099C13.5607 12.2743 12.9873 11.8649 12.3209 11.4551C10.7667 10.4993 8.64015 9.49988 6.49999 9.49988C4.33008 9.49988 2.95075 10.4617 2.12476 11.4327C2.08165 11.4834 2.04008 11.5341 2 11.5846Z"
        fill={getColorVariable()}
      />
    </svg>
  )
}

export const IconColoredHorizon = createIcon({
  l: IconColoredHorizonS,
  m: IconColoredHorizonS,
  s: IconColoredHorizonS,
  xs: IconColoredHorizonS,
  name: 'IconColoredHorizon',
})
